export default function() {
   return {
      history: [],
      ignoreNext: false,
   };
}
